<template>
    <div v-if="twitterReady" class="w-full overflow-hidden">
        <a ref="twitterTimeline" class="twitter-timeline" data-height="500" :href="xLink"></a>
    </div>
    <div v-else class="twitter-fallback">
        <div class="fallback-content">
            <h3>{{ $t('follow_us_on_x') }}</h3>
            <p>{{ $t('Stay_updated_with_our_latest_news_and_updates') }}</p>
            <a :href="xLink" target="_blank" rel="noopener" class="twitter-link"> {{ $t('Follow', { account: twitterHandle }) }} </a>
        </div>
    </div>
</template>

<script>
import { ref, onMounted, nextTick, computed, watch } from 'vue';
import { useRoute } from 'vue-router';

export default {
    setup() {
        const twitterReady = ref(false);
        const twitterTimeline = ref(null);
        const route = useRoute();
        const region = computed(() => window.meta?.region_configuration?.region || 'de');
        const twitterHandle = computed(() => (region.value === 'de' ? 'HKCM1' : 'hkcm_global'));
        const xLink = computed(() => `https://x.com/${twitterHandle.value}`);

        const loadTwitter = () => {
            if (!window.twttr) {
                const script = document.createElement('script');
                script.src = 'https://platform.twitter.com/widgets.js';
                script.async = true;
                script.onload = () => {
                    nextTick(() => {
                        window.twttr.widgets.load();
                    });
                };
                document.head.appendChild(script);
            } else {
                nextTick(() => {
                    window.twttr.widgets.load();
                });
            }

            if (!window.twttr || !window.twttr.widgets) {
                twitterReady.value = false;
            } else {
                twitterReady.value = true;
            }
        };

        const reloadTwitter = () => {
            nextTick(() => {
                if (window.twttr && window.twttr.widgets) {
                    window.twttr.widgets.load();
                }
            });
        };

        onMounted(() => {
            delete window.twttr;
            loadTwitter();
        });

        watch(
            () => route.fullPath,
            () => reloadTwitter(),
            { immediate: true }
        );

        return {
            twitterReady,
            twitterTimeline,
            xLink,
            twitterHandle,
            region
        };
    }
};
</script>
<style scoped>
.twitter-fallback {
    background: white;
    padding: 2rem;
    text-align: center;
    border: 1px solid #e1e8ed;
    border-radius: 12px;
}

.fallback-content {
    max-width: 300px;
    margin: 0 auto;
}

.twitter-logo svg {
    width: 24px;
    height: 24px;
}

.fallback-content h3 {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
    color: #1a1a1a;
}

.fallback-content p {
    color: #666;
    margin-bottom: 1.5rem;
    line-height: 1.5;
}

.twitter-link {
    display: inline-block;
    background: #1da1f2;
    color: white;
    padding: 0.75rem 1.5rem;
    border-radius: 24px;
    text-decoration: none;
    font-weight: 500;
    transition: background-color 0.2s;
}

.twitter-link:hover {
    background: #1a91da;
}
</style>
